import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../AuthContext';
import { OrganizationProvider } from '../OrganizationContext';
import LoadingSpinner from './LoadingSpinner';

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading, user } = useAuth();
  const location = useLocation();
  const isSuperAdminRoute = location.pathname.startsWith('/super-admin');

  if (loading) {
    return (
      <div className="min-h-screen bg-gradient-to-b from-gray-950 via-gray-900 to-gray-900 flex items-center justify-center">
        <LoadingSpinner size="lg" text="Loading..." />
      </div>
    );
  }

  if (!isAuthenticated) {
    // Redirect to appropriate login page based on route
    if (isSuperAdminRoute) {
      return <Navigate to="/super-admin/login" replace state={{ from: location }} />;
    }
    return <Navigate to="/developer/login" replace state={{ from: location }} />;
  }

  // Check if user is trying to access super-admin route but is not a super admin
  if (isSuperAdminRoute && !user?.is_super_admin && user?.user_type !== 'super_admin') {
    return <Navigate to="/developer/login" replace />;
  }

  return (
    <OrganizationProvider>
      {children}
    </OrganizationProvider>
  );
};

export default ProtectedRoute;
